import TTMPropertyLogForm from "./TTMPropertyLogForm.vue";
export default TTMPropertyLogForm;